import HeroSection from "../components/Common/HeroSection";
import BannerSection from "../components/Common/PlatformBannerSection";
import IntelligentEngineeringSection from "../components/DigitalTransformation/IntelligentEngineering";
import IndustriesWeTransform from "../components/DigitalTransformation/IndustriesTransform";
import TransformationModels from "../components/DigitalTransformation/TransformationModels";
import IntelligentChange from "../components/DigitalTransformation/IntelligentChange";
import LandingHero from "../components/Common/LandingHero";
import data from "../content.json";
const DigitalTransfromation = () => {
  // const heroButtons = [
  //   {
  //     label: "Explore Our Solutions",
  //     className: "btn-secondary",
  //     onClick: () => console.log("Get Started clicked"),
  //   },
  //   {
  //     label: "Talk to Our Experts",
  //     className: "btn-outline",
  //     onClick: () => console.log("Get Started clicked"),
  //   },
  // ];

  const models = [
    {
      image: "/assets/digitalTransformation/4section-1.svg",
      title: "Advanced Metering Infrastructure",
      description:
        "Real-time, two-way smart metering that improves monitoring, billing, and utility operations.",
      buttonText: "Explore AMI",
      link: "/ami",
    },
    {
      image: "/assets/digitalTransformation/4section-2.svg",
      title: "Augmented Intelligent Document Automation​",
      description:
        "AI-driven automation that extracts and processes data from documents quickly and accurately.",
      buttonText: "Explore AiDA",
      link: "/aida",
    },
  ];

  return (
    <div>
      {/* Hero Section */}

      <div className="relative z-20 overflow-visible">
        <LandingHero data={data.digitalTransformation.hero} />
      </div>
      
      <div className="md:pt-28">
        <IntelligentEngineeringSection
          leftImage="/assets/digitalTransformation/2section-1.svg"
          rightImage="/assets/digitalTransformation/2section-2.svg"
        />
      </div>

      <IntelligentChange />
      <TransformationModels models={models} />
      <IndustriesWeTransform />
      <BannerSection
        title="Build the Future with"
        highlightedText="Intelligent Transformation"
        description="Partner with Avexa Systems to design, deploy, and scale AI-powered digital solutions that deliver real, measurable impact."
        buttonText="Contact Us"
        buttonLink="/get-in-touch"
        backgroundColor="var(--primary-color)"
        variant="dark"
      />
      <div className="h-8 md:h-12 lg:h-16 bg-white"></div>
    </div>
  );
};

export default DigitalTransfromation;
